import React from "react";

export const Field = ({ label, children }) => (
  <div className="mb-3">
    <div className="text-[14px] font-semibold text-t2 mb-[5px] uppercase tracking-[0.05em]">{label}</div>
    {children}
  </div>
);
